import React from "react";
import { Users, User } from "lucide-react";

/**
 * Two-state pill toggle: "My Items" | "My Team".
 * Persists user's choice per key in localStorage.
 */
export default function ScopeToggle({ value, onChange, storageKey, testIdPrefix = "scope" }) {
  const set = (next) => {
    onChange(next);
    if (storageKey) {
      try { localStorage.setItem(storageKey, next); } catch { /* ignore */ }
    }
  };

  const btnBase = "flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-widest px-3 py-1.5 transition-colors";
  const btnActive = "bg-[#d4af37] text-black";
  const btnInactive = "text-gray-400 hover:text-white";

  return (
    <div className="inline-flex items-center border border-[#262626] rounded-full overflow-hidden" data-testid={`${testIdPrefix}-toggle`}>
      <button
        onClick={() => set("mine")}
        className={`${btnBase} rounded-l-full ${value === "mine" ? btnActive : btnInactive}`}
        data-testid={`${testIdPrefix}-mine`}
      >
        <User className="w-3 h-3" /> My Items
      </button>
      <button
        onClick={() => set("team")}
        className={`${btnBase} rounded-r-full ${value === "team" ? btnActive : btnInactive}`}
        data-testid={`${testIdPrefix}-team`}
      >
        <Users className="w-3 h-3" /> My Team
      </button>
    </div>
  );
}

/**
 * Read persisted scope value or return default.
 */
export function readScope(storageKey, fallback = "mine") {
  try {
    const v = localStorage.getItem(storageKey);
    return v === "team" || v === "mine" ? v : fallback;
  } catch {
    return fallback;
  }
}
